import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { QuestionCard } from "../common";

const questionOptions = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

export const Question6 = ({
  updateQuestion,
  jurisdiction,
  answer,
  updateAnswer,
}) => {
  const [selection, setSelection] = useState(answer || "");
  const navigate = useNavigate();

  const handleSelectionChange = (value) => {
    setSelection(value);
    updateAnswer(value);
    sessionStorage.setItem("answer_q6", value);
  };

  const isNextDisabled = selection === "" || !answer;

  const handleNext = () => {
    if (selection === "no") {
      const contentKey =
        jurisdiction === "parliamentary"
          ? "q6_incomplete_parliamentary"
          : "q6_incomplete_nhs";
      navigate("/cannot-help", { state: { contentKey } });
    } else {
      jurisdiction === "nhs" ? updateQuestion(7) : updateQuestion(8);
    }
  };

  return (
    <QuestionCard
      question="Have you completed their complaints process?"
      options={questionOptions}
      required={true}
      selectedValue={selection}
      onChange={handleSelectionChange}
      onPrevious={() => updateQuestion(5)}
      onNext={handleNext}
      showPrevious={true}
      nextDisabled={isNextDisabled}
      name="completed-process"
    />
  );
};

Question6.propTypes = {
  updateQuestion: PropTypes.func,
  jurisdiction: PropTypes.string,
  answer: PropTypes.string,
  updateAnswer: PropTypes.func,
};
